import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import LoadingOverlay from "../components/LoadingOverlay";

interface Props {
  children: JSX.Element;
}

const RequirePublicOrSystemAdmin: React.FC<Props> = ({ children }) => {
  const { authUser, isFetchingUser } = useUser();
  const location = useLocation();

  if (isFetchingUser) {
    return <LoadingOverlay />;
  }

  // 権限チェック
  const isPublicAdmin = authUser?.isPublicAdmin ?? false;
  const isSystemAdmin = authUser?.isSystemAdmin ?? false;

  if (!isPublicAdmin && !isSystemAdmin) {
    return <Navigate to="/404" state={{ from: location }} replace />;
  }

  return children;
};

export default RequirePublicOrSystemAdmin;
